export default __webpack_public_path__ + "static/media/motor-graphic.ea9a32fd.png";